import { render, staticRenderFns } from "./EmptyTheFields.vue?vue&type=template&id=3860366e&scoped=true"
import script from "./EmptyTheFields.vue?vue&type=script&lang=js"
export * from "./EmptyTheFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860366e",
  null
  
)

export default component.exports